import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminApi from '../../api/AdminApi';
import { AskDialog } from 'ui/src/components';

const UserDetailPage: React.FC = () => {
  const { user_id } = useParams<{ user_id: string }>();
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pwResetOpen, setPwResetOpen] = useState(false);

  const normalize = (v?: string) => (v && v.trim() !== '' ? v : '-');

  const handlePasswordReset = async () => {
    if (!user_id) return;
    try {
      const res = await AdminApi.resetUserPassword(user_id);
      if (res?.data?.status === 'OK') {
        alert('비밀번호가 초기화되었습니다.');
      } else {
        alert(res?.data?.message ?? '초기화 요청이 처리되지 않았습니다.');
      }
    } catch (e) {
      console.error(e);
      alert('비밀번호 초기화 중 오류가 발생했습니다.');
    }
  };

  const openPasswordResetDialog = () => setPwResetOpen(true);
  const confirmPasswordReset = async () => {
    await handlePasswordReset();
    setPwResetOpen(false);
  };

  useEffect(() => {
    const fetchUser = async () => {
      if (!user_id) return;
      try {
        setLoading(true);
        setError(null);
        const res = await AdminApi.getUserDetail(user_id);
        const data = res.data?.data || null;
        setUser(data);
      } catch (e) {
        console.error('사용자 상세 조회 실패:', e);
        setError('조회 실패');
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [user_id]);

  const maskName = (name) => {
    if (!name || name === '-') return name;
    if (name.length <= 2) {
      return `${name[0]}*`;
    }
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
  };

  return (
    <section className="cPage">
      <article className="wrap_inner leftMargin">
        <article className="pageTitArea">
          <div className="pageTitLeft">
            <button
              type="button"
              className="bBack"
              onClick={() => navigate(-1)}
            >
              <span>뒤로가기 버튼</span>
            </button>
            <div className="pageTit">사용자 상세</div>
          </div>
        </article>

        <article className="pageConArea">
          {loading ? <div>로딩 중...</div> : null}
          {!loading && error ? <div>{error}</div> : null}
          {!loading && !error && (
            <div className="cTableWrap mt40">
              <div className="cTableTopArea">
                <div className="cTableTopLeft">
                  <div className="cTableTopTit">사용자 정보</div>
                </div>
              </div>

              <div className="cDetailTableArea">
                <table className="cDetailTable">
                  <colgroup>
                    <col width="13%" />
                    <col width="*" />
                    <col width="13%" />
                    <col width="*" />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>소속</th>
                      <td>
                        <div className="cLeft">
                          {normalize(
                            [user?.ctpv_nm, user?.sgg_nm, user?.dept_nm].filter((s) => s && s.trim() !== '').join(' '),
                          )}
                        </div>
                      </td>
                      <th>성명</th>
                      <td>
                        <div className="cLeft">{maskName(normalize(user?.user_nm))}</div>
                      </td>
                    </tr>
                    <tr>
                      <th>아이디</th>
                      <td>
                        <div className="cLeft">{normalize(user?.user_id)}</div>
                      </td>
                      <th>비밀번호</th>
                      <td>
                        <div
                          className="cLeft"
                          style={{ display: 'flex', alignItems: 'center', gap: '16px' }}
                        >
                          ********
                          <button
                            type="button"
                            className="pwResetBtn"
                            onClick={openPasswordResetDialog}
                          >
                            <span>비밀번호 초기화</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>직위</th>
                      <td>
                        <div className="cLeft">{normalize(user?.jbps_nm)}</div>
                      </td>
                      <th>가입등록일</th>
                      <td>
                        <div className="cLeft">{normalize(user?.reg_dt_nm)}</div>
                      </td>
                    </tr>
                    <tr>
                      <th>최근수정일</th>
                      <td>
                        <div className="cLeft">{normalize(user?.mod_dt_nm)}</div>
                      </td>
                      <th>최근접속일</th>
                      <td>
                        <div className="cLeft">{normalize(user?.lat_lgn_dt_nm)}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="cTableBottomArea">
                <div className="cTableBottomRight">
                  <button
                    type="button"
                    className="bHeight03 bLineType03 bList"
                    onClick={() => navigate('/main/admin/user-list')}
                  >
                    <span>목록</span>
                  </button>
                </div>
              </div>
              <AskDialog
                open={pwResetOpen}
                setOpen={setPwResetOpen}
                okCallback={confirmPasswordReset}
                message="비밀번호를 초기화하시겠습니까?"
              />
            </div>
          )}
        </article>
      </article>
    </section>
  );
};

export default UserDetailPage;
